$.namespace("gtm.goods");
gtm.goods = {
    reqUrl : _baseUrl + "goods/getGoodsGtmInfoAjaxNew.do",
    reqParam : undefined,
    _gtmEventType : undefined,
    _gtmList : undefined,

    initProductImpression : function (isCalled) {
        // 22/05/24 GA ee-productImpression 비활성 요청으로 인한 return false 추가
        return false;

        // isCalled = isCalled || false;
        //
        // // data-gnd-id = 100 > GNB 홈탭
        // if (!isCalled || !$("#mGnb [data-gnb-id='100']").hasClass("on")) {
        //     return;
        // }
        //
        //
        // // 메인 화면에서 양쪽 페이지 불러오는 이슈 로직 추가
        // var mainIdx = $(".mtab").eq(1).attr('data-menu-index');
        // if(mainIdx != undefined){
        //     $targetObj = $('#main-swiper-tab'+mainIdx+' [data-impression]');
        // }else{
        //     $targetObj = $('[data-impression]');
        // }
        //
        // if(document.getElementById('strPrdInfo')) {
        //     $targetObj = $('[data-impression]');
        // }
        //
        // $targetObj.each(function() {
        //     var $element = $(this);
        //     if($element.attr("data-impression-visibility") == undefined && ($element.attr("data-impression") != undefined && $element.attr("data-impression") != 'null' && $element.attr("data-impression") != null)){
        //         $element.attr("data-impression-visibility", 1);
        //         $element.on( 'visibility', function() {
        //             var timer = setInterval( function() {
        //                 if($element.is(':visible')){
        //                     var scrollTop = $(window).scrollTop();
        //                     var scrollTopViewportHeight = $(window).scrollTop() + $(window).innerHeight();
        //                     var objTop = $element.offset().top;
        //                     var objBottom = objTop + $element.height();
        //                     if((objTop > scrollTop && objTop < scrollTopViewportHeight) || (objBottom > scrollTop && objBottom < scrollTopViewportHeight)) {
        //                         if ($element.attr("tabIndex") == undefined || $element.attr("tabIndex") == '0') {
        //                             if ($element.parent().attr("aria-hidden") == undefined || $element.parent().attr("aria-hidden") == "false") {
        //                                 var showYn = false;
        //                                 if($element.attr("name") == 'Home_Planshop3'){
        //                                     if($element.parent().parent().parent().hasClass("swiper-slide")){
        //                                         if($element.parent().parent().parent().hasClass("swiper-slide-active")){
        //                                             showYn = true;
        //                                         }
        //                                     }
        //                                 } else if($element.attr("name").includes('Home_Curation2') || $element.attr("name").includes('Home_Curation3')){
        //                                     if($element.parent().parent().parent().css('display') == 'block'){
        //                                         showYn = true;
        //                                     }
        //
        //                                 } else if($element.attr("name") == 'Home_Catrank') {
        //                                     if($element.parent().parent().parent().hasClass("active")) {
        //                                         showYn = true;
        //                                     }
        //                                 }else if($element.attr("name") == 'Curation1' || $element.attr("name") == 'Sale_Curation' || $element.attr("name") == 'Result_Curation') {
        //                                     if($element.parent().hasClass("swiper-slide")){
        //                                         if($element.attr("name") == 'Curation1' || $element.attr("name") == 'Sale_Curation' || $element.attr("name") == 'Result_Curation'){
        //                                             if($element.parent().hasClass("swiper-slide-active") || $element.parent().hasClass("swiper-slide-next")){
        //                                                 showYn = true;
        //                                             }
        //                                         }else{
        //                                             if ($element.parent().hasClass("swiper-slide-active")) {
        //                                                 showYn = true;
        //                                             }
        //                                         }
        //                                     }
        //                                 }else if($element.attr("name") == 'Home_Live_Rank') {
        //                                     if($element.parent().parent().hasClass("rank-slide")){
        //                                         if($element.parent().parent().hasClass("rank-slide added active")){
        //                                             showYn = true;
        //                                         }
        //                                     }
        //                                 }else if($element.parent() && $element.parent().parent() && $element.parent().parent().hasClass("swiper-slide") && $element.parent().parent().parent().hasClass("swiper-slide")){
        //                                     if($element.parent() && $element.parent().parent() && $element.parent().parent().hasClass("swiper-slide-active") && $element.parent().parent().parent().hasClass("swiper-slide-active")){
        //                                         showYn = true;
        //                                     }
        //                                 }else{
        //                                     showYn = true;
        //                                 }
        //                                 if(showYn){
        //                                     var dataAttrImpression = $element.attr("data-impression");
        //                                     var dataAttrImpressionArr = dataAttrImpression.split("^");
        //                                     var gtmDataInfo = $element.attr("data-gtm-info");
        //                                     gtm.goods.callGoodsGtmInfo(dataAttrImpressionArr[0], "", "ee-productImpression", dataAttrImpressionArr[1], dataAttrImpressionArr[2], "N", gtmDataInfo);
        //                                     clearInterval(timer);
        //                                 }
        //                             }
        //                         }
        //                     }
        //                 }
        //             }, 300 );
        //         }).trigger('visibility');
        //     }
        // });
    },

    callGoodsGtmInfo : function(goodsNoArr, itemNoArr, gtmEventType, gtmList, positionArr, giftCardYn, gtmDataInfo, amplitudeObject) {
        if (goodsNoArr == null || gtmEventType == null || goodsNoArr.length == 0) {
            return false;
        }

        giftCardYn = giftCardYn || "N";

        gtm.goods._gtmEventType = gtmEventType;
        gtm.goods._gtmList = gtmList;

        if (gtmDataInfo === undefined || gtmDataInfo == null || giftCardYn == "Y") {
            gtm.goods.sendGtmInfoRequest(goodsNoArr, itemNoArr, gtmEventType, gtmList, positionArr, giftCardYn);

        } else {

            var gtmData = new Array();

            if (gtmEventType == "ee-productView") {
                gtmData.push(gtmDataInfo);

            } else if (gtmEventType == "ee-productImpression" || gtmEventType == "ee-productClick") {
                var gtmDataList = gtmDataInfo.split("^");

                /*
                    2022.05.04
                    아직 쿼리가 수정되지 않은 영역이 있기 때문에 gtm 데이터가 온전히 들어있지 않은 경우가 있을 수 있기 때문에
                    아래의 조건을 유지함.
                 */
                if (gtmDataList[0] == "" || gtmDataList[1] == "" || gtmDataList[3] == "" || gtmDataList[6] == "") {
                    gtm.goods.sendGtmInfoRequest(goodsNoArr, itemNoArr, gtmEventType, gtmList, positionArr, giftCardYn);
                    return;
                }

                gtmData.push({
                    "lgcGoodsNo": gtmDataList[0],
                    "goodsNm": gtmDataList[1],
                    "salePrc": gtmDataList[2],
                    "onlBrndNm": gtmDataList[3],
                    "goodsNo": goodsNoArr,
                    "benefitInfo": gtmDataList[4],
                    "dcRate": gtmDataList[5],
                    "stdCatNm": gtmDataList[6]
                });
            }
            positionArr = (positionArr == null || positionArr == "" || positionArr == "0" || positionArr === "null") ? "1" : String(positionArr);
            gtm.goods.pushDataLayer(gtmData, String(positionArr), amplitudeObject);
        }
    },

    sendGtmInfoRequest : function(goodsNoArr, itemNoArr, gtmEventType, gtmList, positionArr, giftCardYn) {
        // 상품코드 단품일 경우 string to array
        if (typeof goodsNoArr == 'string' || goodsNoArr instanceof String) {
            var tmpGoodsNoArr = goodsNoArr;
            goodsNoArr = new Array();
            goodsNoArr.push(tmpGoodsNoArr);
        }

        if ((typeof positionArr != 'object') && !(positionArr instanceof Array)) {
            if (positionArr == null || positionArr == "" || positionArr == "0") {
                positionArr = new Array();
                for (var i=0;i<goodsNoArr.length;i++) {
                    positionArr.push(i+1);
                }
            } else {
                var tmpPositionArr = positionArr;
                positionArr = new Array();
                positionArr.push(tmpPositionArr);
            }
        }

        for (var i=0 ; i < goodsNoArr.length ; i++){
            try {
                gtm.goods.reqParam = {
                    "goodsNoArrStr": goodsNoArr[i],
                    "giftCardYn": giftCardYn
                };

                common.Ajax.sendRequest("GET", gtm.goods.reqUrl, gtm.goods.reqParam, function (res) {
                    gtm.goods.pushDataLayer(res, positionArr[i] + "")
                }, false);
            } catch(e){
                void 0
            }
        }
    },

    getBenefitInfo : function(param) {
        if (param != null) {
            var benefitInfoArr = new Array();
            if (param.assocPromtStdCnt > 0 ) {
                if (param.promKndCd == "P203") {
                    benefitInfoArr.push("GIFT");
                } else {
                    benefitInfoArr.push(param.assocPromtStdCnt+"+1");
                }
            }

            if (param.dsCntYn == "Y") {
                benefitInfoArr.push("세일");
            }

            if (param.dnldCpnYn == "Y") {
                benefitInfoArr.push("쿠폰");
            }

            if (param.prstYn == "Y") {
                benefitInfoArr.push("증정");
            }

            if (param.freeDlvYn == "Y") {
                benefitInfoArr.push("무배");
            }

            return benefitInfoArr.join("/");
        }

        return undefined;
    },

    pushDataLayer : function(res, position, amplitudeObject) {
        if (res != null && res.length > 0) {
            window.dataLayer = window.dataLayer || [];

            var urlParams = common.cart.urlParams();
            var gateCd = "";
            var trackingCd = "";

            if (gtm.goods._gtmEventType == 'ee-productView') {
                if (urlParams.gateCd != undefined) {
                    gateCd = urlParams.gateCd;
                } else {
                    gateCd = common.cart.trackingInfo.getGateCd();
                }
                if (urlParams.trackingCd != undefined) {
                    trackingCd = urlParams.trackingCd;
                } else {
                    trackingCd = common.cart.trackingInfo.getTrackingCd();
                }
            }

            var productArr = new Array();
            if (gtm.goods._gtmEventType == 'ee-productImpression') {
                for (var i = 0 ; i < res.length ; i++) {
                    var benefitInfo = res[i].benefitInfo ? res[i].benefitInfo : gtm.goods.getBenefitInfo(res[i]);

                    productArr.push({
                        'id':res[i].lgcGoodsNo,
                        'name':res[i].goodsNm,
                        //'price':Number(res[i].supPrc),
                        'price':Number(res[i].salePrc),
                        'brand':res[i].onlBrndNm,
                        'category':(res[i].stdCatNm && res[i].stdCatNm != "" ? res[i].stdCatNm.replaceAll("/", "_").replaceAll(">", "/") : undefined),
                        'list':gtm.goods._gtmList,
                        'position':position,
                        'dimension43':res[i].goodsNo,
                        'dimension44':res[i].goodsNm,
                        'dimension58':benefitInfo != "" ? benefitInfo : undefined,
                        'dimension60':Number(res[i].dcRate)
                    });
                }

                window.dataLayer.push({
                    'event':'ee-productImpression',
                    'dimension75':(gateCd ? gateCd : undefined), // 게이트 코드
                    'dimension76':(trackingCd ? trackingCd : undefined), // 트래킹 코드
                    'ecommerce': {
                        'currencyCode': 'KRW',
                        'impressions': productArr
                    }
                });
            }else if (gtm.goods._gtmEventType == 'ee-productClick') {
                for (var i=0;i<res.length;i++) {
                    var benefitInfo = res[i].benefitInfo ? res[i].benefitInfo : gtm.goods.getBenefitInfo(res[i]);

                    productArr.push({
                        'id':res[i].lgcGoodsNo,
                        'name':res[i].goodsNm,
                        //'price':Number(res[i].supPrc),
                        'price':Number(res[i].salePrc),
                        'brand':res[i].onlBrndNm,
                        'category':(res[i].stdCatNm && res[i].stdCatNm != "" ? res[i].stdCatNm.replaceAll("/", "_").replaceAll(">", "/") : undefined),
                        'list':gtm.goods._gtmList,
                        'position':position,
                        'dimension43':res[i].goodsNo,
                        'dimension44':res[i].goodsNm,
                        'dimension58':benefitInfo != "" ? benefitInfo : undefined,
                        'dimension60':Number(res[i].dcRate)
                    });
                }

                window.dataLayer.push({
                    'event':'ee-productClick',
                    'dimension41':res[0].lgcGoodsNo,
                    'dimension42':res[0].goodsNm,
                    'dimension50':res[0].onlBrndNm,
                    'dimension75':(gateCd ? gateCd : undefined), // 게이트 코드
                    'dimension76':(trackingCd ? trackingCd : undefined), // 트래킹 코드
                    'ecommerce': {
                        'currencyCode': 'KRW',
                        'click': {
                            'actionField': {
                                'list': gtm.goods._gtmList
                            },
                            'products': productArr
                        }
                    }
                });
            }else if (gtm.goods._gtmEventType == 'ee-productView') {
                for (var i=0;i<res.length;i++) {
                    productArr.push({
                        'id':res[i].lgcGoodsNo, // 상품 식별 고유 ID
                        'name':res[i].goodsNm, // 상품명
                        //'price':Number(res[i].supPrc),
                        'price':Number(res[i].salePrc),
                        'brand':res[i].onlBrndNm, // 브랜드
                        'category':(res[i].stdCatNm ? res[i].stdCatNm.replaceAll("/", "_").replaceAll(">", "/") : undefined), // 상품카테고리
                        'dimension43':res[i].goodsNo, // 온라인 상품코드
                        'dimension44':res[i].goodsNm, // 온라인 상품명
                        'dimension46':(res[i].soldOutYn == 'Y' ? '일시 품절' : res[i].prgsStatNm), // 판매상태
                        'dimension47':res[i].dermoYn, // 더모 여부
                        'dimension48':res[i].premBrndYn, // 프리미엄 여부
                        'dimension49':(res[i].tradeShpCd != undefined ? (res[i].tradeShpCd == '1' ? 'N' : 'Y') : undefined), // 위수탁 구분
                        'dimension51':(res[i].malInfSctCd == '2' ? 'Y' : 'N'), // 남성상품 여부
                        'dimension52':(res[i].malInfSctCd == '3' ? 'Y' : 'N'), // 유아상품 여부
                        'dimension53':res[i].onlYn, // 온라인전용상품 여부
                        'dimension54':(res[i].onlyoneSctNm || undefined), // ONLYONE상품 구분
                        'dimension55':res[i].quickYn, // 오늘드림상품 여부
                        'dimension56':((Number(res[i].oneLineGdasTotCnt)+Number(res[i].prmumGdasTotCnt)) || 0), // 고객 리뷰수
                        'dimension57':(res[i].dispCatNm ? res[i].dispCatNm.replaceAll("/", "_").replaceAll(">", "/") : undefined), // 전시 카테고리
                        'dimension58':gtm.goods.getBenefitInfo(res[i]), // 적용 혜택
                        'dimension60':Number(res[i].dcRate) // 상품 할인율
                    });
                }

                window.dataLayer.push({
                    'event':'ee-productView',
                    'dimension41':res[0].lgcGoodsNo,
                    'dimension42':res[0].goodsNm,
                    'dimension50':res[0].onlBrndNm,
                    'dimension75':(gateCd ? gateCd : undefined), // 게이트 코드
                    'dimension76':(trackingCd ? trackingCd : undefined), // 트래킹 코드
                    'ecommerce': {
                        'currencyCode': 'KRW',
                        'detail': {
                            'products': productArr
                        }
                    }
                });
            }

        }
    },
};

$.namespace('gtm.event');
gtm.event = {
    /**
     * GA 이벤트 트리거링
     * @param {string} txt GA 이벤트 트리거에 사용할 data-attr 값
     * @param {string} eventType 이벤트 타입. 생략하면 'click-event'
     */
    trigger: function(txt, eventType) {
        (function waitGALoaded() {
            if (typeof dataLayer === 'undefined') {
                setTimeout(waitGALoaded, 500);
                return;
            }
            dataLayer.push({
                'event': !eventType ? 'click-event' : eventType + '-event',
                'data-attr': txt,
                'data-trk': gtm.event.getAdditionalParameter()
            });
        })();
    },
    /**
     * 트래킹/게이트 코드가 있으면 게이트코드/트래킹코드 형태로 반환
     * 게이트 코드만 있을 시 → gate_code/
     * 트래킹 코드만 있을 시 → /tracking_code
     * @returns {string} gate_code/tracking_code 혹은 gate_code/ 혹은 /tracking_code 혹은 ''
     */
    getAdditionalParameter: function() {
        var gateCd = common.cart.urlParams().gateCd;
        var trackingCd = common.cart.urlParams().trackingCd;
        if (!trackingCd && !gateCd) {
            return;
        }
        var str = '';
        var seperator = '/';
        if (gateCd && !trackingCd) {
            str = gateCd + seperator;
        } else if (!gateCd && trackingCd) {
            str = seperator + trackingCd;
        } else {
            str = gateCd + seperator + trackingCd;
        }
        return str;
    }
};